import { useQuery } from "react-query";
import { UserAPI } from 'api/user';

export default function useUserParticipants(id) {
  return useQuery(
    ['userParticipants', id],
    () => UserAPI.getUserParticipants(id),
  );
}
